import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/for-organizers")({
  beforeLoad: () => {
    throw redirect({
      to: "/organizers",
      statusCode: 301,
    });
  },
});
